module.exports = __webpack_public_path__ + "static/media/compose.411ebe30.gif";